import { Box, Typography } from '@mui/material';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { useTranslation } from 'react-i18next';
import { FieldLabel, FormField } from '../styled';

interface DocSourceInfoProps {
  sourceFileName?: string;
}

const DocSourceInfo = ({ sourceFileName }: DocSourceInfoProps) => {
  const { t } = useTranslation('common');

  return (
  <FormField>
    <FieldLabel>{t('assistant.ragStorageDialog.source')}</FieldLabel>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        p: '10px 12px',
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'var(--am-border)',
        backgroundColor: 'var(--am-surface)',
      }}
    >
      <InsertDriveFileOutlinedIcon
        sx={{ color: 'var(--am-text-secondary)', fontSize: 20, flexShrink: 0 }}
      />
      <Typography
        variant="body2"
        sx={{ color: 'var(--am-text-secondary)', flex: 1 }}
        noWrap
      >
        {sourceFileName ?? t('assistant.ragStorageDialog.uploadedDocument')}
      </Typography>
    </Box>
  </FormField>
  );
};

export default DocSourceInfo;
